"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _AppSelect = _interopRequireDefault(require("@rsuite/icon-font/lib/action/AppSelect"));

// Generated by script, don't edit it please.
var AppSelect = (0, _createSvgIcon["default"])({
  as: _AppSelect["default"],
  ariaLabel: 'app select',
  category: 'action',
  displayName: 'AppSelect'
});
var _default = AppSelect;
exports["default"] = _default;
module.exports = exports.default;